"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// React
const react_1 = __importDefault(require("react"));
// Material ui
const core_1 = require("@material-ui/core");
// Router
const react_router_1 = require("react-router");
// Core
const profile_core_1 = require("./profile.core");
// Styles
const user_1 = require("@dsk-lib/user");
const profile_style_1 = require("./profile.style");
const digi_react_form_1 = __importDefault(require("digi-react-form"));
const react_redux_1 = require("react-redux");
const profile_service_1 = require("./profile.service");
const user_services_1 = require("../../services/user.services");
const ProfileForm = react_1.default.memo(digi_react_form_1.default.Profile);
const Profile = ({ setNotificationMessage, schoolApiEndPoint, userProfilVersion, userApiEndPoint, Loader, service, constraintApiEndPoint }) => {
    /** Component styles */
    const classes = profile_style_1.useProfileStyle();
    const history = react_router_1.useHistory();
    const [state, setState] = react_1.default.useState({ stepperMode: true, loading: true });
    /** Authentication */
    const { authentication, fetchWithCredentials } = user_1.useUserAuthentication();
    /** store */
    const dispatch = react_redux_1.useDispatch();
    const sendNotification = (message, type) => {
        dispatch(setNotificationMessage(message, type));
    };
    const sendNotificationCallback = react_1.default.useCallback(sendNotification, []);
    /**
     * Success submit callback
     * @param message
     */
    const onSuccess = (message) => {
        dispatch(setNotificationMessage(message, 'success'));
        profile_core_1.handleSubmitSuccessRedirect();
    };
    /**
     * Fail submit callback
     * @param message
     */
    const onFail = (message) => {
        dispatch(setNotificationMessage(message, 'error'));
    };
    /** Handle inscription redirection */
    react_1.default.useEffect(() => {
        const showProfile = (profileInfo) => {
            profile_core_1.initProfileLib(schoolApiEndPoint);
            setState(Object.assign(Object.assign({}, state), { loading: false, profileInfo, stepperMode: !profileInfo.status }));
        };
        if (!authentication.isPending && !authentication.isAuthenticated) {
            history.push('/');
        }
        if (state.loading && state.profileInfo) {
            showProfile(state.profileInfo);
        }
        else if (!authentication.isPending && authentication.isAuthenticated && state.loading) {
            user_services_1.getUserInfo(userApiEndPoint, schoolApiEndPoint, userProfilVersion, fetchWithCredentials)
                .then(userData => {
                showProfile(userData);
            })
                .catch(() => {
                sendNotificationCallback('Une erreur est survenue, impossible de récupérer les données de votre profil. Veuillez réessayer ultérieurement. Si le problème persiste contactez nous via le lien en bas de page.', 'error');
            });
        }
    }, [authentication, history, state, fetchWithCredentials, sendNotificationCallback]);
    const ProfilLoader = Loader !== null && Loader !== void 0 ? Loader : core_1.CircularProgress;
    if (state.loading || !state.profileInfo) {
        return state.loading ? react_1.default.createElement(ProfilLoader, null) : null;
    }
    return (react_1.default.createElement(core_1.Grid, { container: true, item: true, alignContent: "center", alignItems: "center", direction: "column" },
        react_1.default.createElement("div", { className: classes.root },
            react_1.default.createElement(ProfileForm, { constraintUrl: constraintApiEndPoint, serviceName: service, initialValues: state.profileInfo, stepper: state.stepperMode, handleSubmit: (userData) => profile_core_1.saveUserProfile(fetchWithCredentials, userData, userProfilVersion, userApiEndPoint, onSuccess, onFail), deleteAccountRedirectUrl: '?logout=true', deleteUser: () => __awaiter(void 0, void 0, void 0, function* () { return yield profile_service_1.deleteAccount(userApiEndPoint, fetchWithCredentials); }), deleteAccountUrl: `${userApiEndPoint}/users/me` }))));
};
exports.default = Profile;
//# sourceMappingURL=Profile.js.map